import { Link } from "react-router-dom";
import { CalendarCheck, Info } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { SectionHead } from "../components/SectionHead";
import { Reveal } from "../components/motion";
import { CataractServices } from "../components/CataractServices";

const Cataract = () => (
  <>
    <PageHero
      kicker="Cataract Specialist in Janak Puri"
      testid="cataract-hero"
      lines={[
        <>Advanced</>,
        <>
          <span className="font-serif italic font-semibold text-brand-bright">cataract</span> surgery.
        </>,
      ]}
      sub="Micro-incisional, sutureless cataract surgery with premium intra-ocular lenses — planned around your eyes and your life."
    />

    <section className="py-20 sm:py-28" data-testid="cataract-details-section">
      <div className="container-x max-w-5xl">
        <SectionHead
          chapter="01"
          kicker="Surgery & Lenses"
          title="Clearer vision, carefully planned"
          sub="What modern cataract surgery at iNetra involves, and the lens options available to you."
        />
        <div className="mt-12">
          <CataractServices />
        </div>
        <Reveal delay={0.1} className="mt-10">
          <div className="rounded-2xl border border-aqua/25 bg-aqua-mist p-6 flex gap-4" data-testid="cataract-note">
            <Info className="w-5 h-5 text-aqua shrink-0 mt-0.5" aria-hidden="true" />
            <p className="text-sm text-slate-700 leading-relaxed">
              Cataract surgery is one of the most commonly performed eye procedures, but outcomes depend on careful
              evaluation and honest lens selection. At iNetra, we explain your options clearly — including realistic
              expectations — so you can decide with confidence.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="mt-10 text-center">
          <Link to="/contact#book" className="btn-primary" data-testid="cataract-book-button">
            <CalendarCheck className="w-4 h-4" aria-hidden="true" /> Book a Cataract Evaluation
          </Link>
        </Reveal>
      </div>
    </section>
  </>
);

export default Cataract;
